import loader from 'containers/modalsDispatcher/loader';

export const showInvoiceModal = loader({
  key: 'INVOICE_MODAL',
  getModal: () => import(/* add-transport-modal */'./InvoiceModal'),
});
